module.exports = __webpack_public_path__ + "media/images/icons/filled/skin-5b3d22d998a7db5091d91fcbe324ff51.svg";